module.exports = __webpack_public_path__ + "img/blog-page-3.3da4a70f.jpg";